import { render, staticRenderFns } from "./Family-statement-template-form.vue?vue&type=template&id=5f56365e&scoped=true"
import script from "./Family-statement-template-form.vue?vue&type=script&lang=js"
export * from "./Family-statement-template-form.vue?vue&type=script&lang=js"
import style0 from "./Family-statement-template-form.vue?vue&type=style&index=0&id=5f56365e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f56365e",
  null
  
)

export default component.exports